"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderIncentiveCommand = void 0;
class RenderIncentiveCommand extends CustomEvent {
    constructor(referrer, tabToShow, referrerDirect) {
        super('RenderAuthenticationService', {
            detail: {
                referrer,
                tabToShow,
                referrerDirect,
            },
        });
    }
}
exports.RenderIncentiveCommand = RenderIncentiveCommand;
